// extracted by mini-css-extract-plugin
module.exports = {"helpMePrice":"helpMePrice_Tlk93","trigger":"trigger_JZEFH","triggerMargin":"triggerMargin_3U_3M"};